import { useEffect, useState } from 'react';

/**
 * A phone's width: up to here the sidebar starts as its icon rail and opens
 * over the page instead of pushing it aside. index.css has the same number.
 */
export const NARROW_SCREEN = '(max-width: 700px)';

function matches(query) {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query).matches
    : false;
}

/** Whether the screen is a phone's width now; follows rotating and resizing. */
export default function useNarrowScreen(query = NARROW_SCREEN) {
  const [narrow, setNarrow] = useState(() => matches(query));

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const list = window.matchMedia(query);
    const update = () => setNarrow(list.matches);
    update();
    list.addEventListener('change', update);
    return () => list.removeEventListener('change', update);
  }, [query]);

  return narrow;
}
